import React from 'react';
import { useQuery } from '@apollo/client';
import OrderBy from 'lodash/orderBy';
import styled from 'styled-components';

import Money from 'core/api/Money';
import { NavigationHeader } from 'onramp/ui/components';
import { Flex, Box, Hr, Text } from 'core/ui/atoms';
import { LIST_INVOICES } from 'core/api/apollo/queries';
import { ReactComponent as InvoiceIcon } from 'core/assets/images/V2/icons/InvoiceIcon.svg';
import { isLoading } from 'core/api/loadingHelpers';
import Loading from 'core/ui/components/Loading';

const MyInvoicesPage = () => {
  const { loading, data: { listInvoices = [] } = {} } = useQuery(LIST_INVOICES);
  const invoices = OrderBy(listInvoices.filter((invoice) => !invoice.voided), 'date', 'desc');

  if (isLoading(loading, invoices)) {
    return <Loading />;
  }

  const RenderInvoices = () => {
    return invoices.map((invoice, index) => {
      return (
        <InvoiceItem
          key={index}
          as="a"
          href={invoice?.pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Flex direction='row' alignItems='center' justifyContent='space-between' width='100%'>
            <Flex direction='row' alignItems='flex-start' gap='12px'>
              <InvoiceIcon />
              <Flex direction='column' alignItems='flex-start'>
                <PrimaryText>Invoice Number {invoice?.invoiceId}</PrimaryText>
                <SubText>{invoice?.date}</SubText>
              </Flex>
            </Flex>
            <PrimaryText>{Money(invoice?.amount).toFormat('$0,0')}</PrimaryText>
          </Flex>
        </InvoiceItem>
      );
    });
  };

  return (
    <Box>
      <NavigationHeader title="My Invoices" />
      <Hr />
      <InvoiceContainer>
        <RenderInvoices />
      </InvoiceContainer>
    </Box>
  );
};

const PrimaryText = styled(Text)`
  font-family: ${(p) => p.theme.typography.familyLarken};
  color: ${(p) => p.theme.colors.primaryV2};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin: 0px;
`;

const SubText = styled(Text)`
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${(p) => p.theme.typography.familyPoppins};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0px;
`;

const InvoiceContainer = styled(Box)`
  padding: 16px;
  display: flex;
  flex-direction: column;
`;

const InvoiceItem = styled(Box)`
  padding: 10px 0;

  &:last-child {
    border-bottom: none;
  }
`;

export default MyInvoicesPage;
